import $ from 'jquery';
import { getAccessToken } from '../utils/authStorage';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

(function initAjaxInterceptor() {
  $.ajaxPrefilter(function (options) {
    if (typeof options.url === 'string' && options.url.startsWith('/')) {
      options.url = API_BASE + options.url;
    }

    // attach access token if present
    const token = getAccessToken();
    if (token) {
      options.headers = options.headers || {};
      // don't override explicit header
      if (!options.headers.Authorization) {
        options.headers.Authorization = `Bearer ${token}`;
      }
    }

    // set default contentType for JSON unless it's FormData or user set it already
    if (!options.contentType && !(options.data instanceof FormData)) {
      options.contentType = options.contentType || 'application/json';
    }
  });
})();
